import React from 'react';
import { Heart } from 'lucide-react';
export function LoadingOrb() {
  return <div className="flex flex-col items-center justify-center" data-id="element-278" data-mp="qufgqaane81c">
      <div className="w-[120px] h-[120px] rounded-full bg-primary flex items-center justify-center animate-heartbeat shadow-elevated" data-id="element-279" data-mp="qupam8ytczcb">
        <Heart size={48} className="text-white fill-white" data-id="element-280" data-mp="zuvm5paybp8u" />
      </div>
    </div>;
}